//// sidebar
(function($, window, undefined) {

  var defaults = {}

  function wbskSideBar(element,settings) {
    this.sidebar = $(element)
    this.openCtrlr = settings.openCtrlr
    this.closeCtrlr = this.sidebar.find('.wbsk-ui-sidebar__close')
    this.container = this.sidebar.find('.wbsk-ui-sidebar__container')
    this.init()
  }

  wbskSideBar.prototype = {
    init: function() {      
      var _this = this
      
      //bind handlers
      this.openCtrlr.on('click', function(e) {
        e.preventDefault()
        if(!_this.isOpen){
          _this.open()
        }else{
          _this.close()
        }
      })  
      
      this.closeCtrlr.click(function(e) {
        e.preventDefault()
        _this.close()  
        return false
      })  
    },
    
    open:function(){
      $('body').addClass('body-masked')
      this.isOpen = true
      this.sidebar.show()
      var event = new CustomEvent('open' , {bubbles: true});
      event.wbskSideBar = this
      this.sidebar[0].dispatchEvent(event);
    },
    
    close:function(){
      $('body').removeClass('body-masked')
      this.isOpen = false
      this.sidebar.hide()
      var event = new CustomEvent('close' , {bubbles: true});
      event.wbskSideBar = this
      this.sidebar[0].dispatchEvent(event);
    },
  }
  
  $.fn.wbskSideBar = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskSideBar', new wbskSideBar(this, settings))
    })
  }

}(jQuery, window));
